// extracted by mini-css-extract-plugin
export default {"event-form-popups":"EventFormPopups_event-form-popups__cboQU","confirm-wrapper":"EventFormPopups_confirm-wrapper__WD0O1"};